import CancelTerminateModal from './CancelTerminateModal';
import OverrideEnrollmentStatusModal from './OverrideEnrollmentStatusModal';
import PremiumHistoryModal from './PremiumHistoryModal';
import ReinstateEnrollmentModal from './ReinstateEnrollmentModal';
import ResendTransactionsModal from './ResendTransactionsModal';
import ResultModal from './ResultModal';
import { MODAL_KEYS } from './modalKeys';

export const modalConfig = {
    [MODAL_KEYS.RESEND_TRANSACTIONS]: {
        id: 'resendTransactions',
        modalComponent: ResendTransactionsModal,
    },
    [MODAL_KEYS.CANCEL_TERMINATE]: {
        id: 'cancelTerminate',
        modalComponent: CancelTerminateModal,
    },
    [MODAL_KEYS.OVERRIDE_ENROLLMENT_STATUS]: {
        id: 'overrideEnrollmentStatus',
        modalComponent: OverrideEnrollmentStatusModal,
    },
    [MODAL_KEYS.PREMIUM_HISTORY]: {
        id: 'premiumHistory',
        modalComponent: PremiumHistoryModal,
    },
    [MODAL_KEYS.REINSTATE_ENROLLMENT]: {
        id: 'reinstateEnrollment',
        modalComponent: ReinstateEnrollmentModal,
    },
    [MODAL_KEYS.RESULT]: {
        id: 'resultModal',
        modalComponent: ResultModal,
    },
};
